import React from 'react'

import { Portlet, Row, Col, Button, Form } from '_zari/core'

import { ZariContext } from '_zari/context'

import { DownloadAxiosFile } from 'utils'

import { SelectMesContabilidad } from 'sharedComponents/select'

import { TiposDeReporteCentrosCostos } from 'constants/index'

import * as ModulosCostosService from 'services/modulosCostos.service'

const ReporteModuloCosto = () => {
  const __zariContext = React.useContext(ZariContext)

  const [tipoDeReporte, setTipoDeReporte] = React.useState(TiposDeReporteCentrosCostos.MENSUAL)
  const [mesSeleccionado, setMesSeleccionado] = React.useState('')
  const [flagAcumulado, setFlagAcumulado] = React.useState(true)

  const clickDescargarReporte = React.useCallback(() => {
    if (tipoDeReporte === TiposDeReporteCentrosCostos.MENSUAL) {
      __zariContext.loader.open('Descargando reporte modulos de costos mensual...')
      ModulosCostosService.descargarReporteFormato10p2xMes({ mes: mesSeleccionado, flagAcumulado })
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
        })
    } else {
      __zariContext.loader.open('Descargando reporte modulos de costos anual...')
      ModulosCostosService.descargarReporteFormato10p2xAnio()
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
        })
    }
  }, [mesSeleccionado, __zariContext, tipoDeReporte, flagAcumulado])

  return (
    <Portlet>
      <Portlet.Header title='Reporte Modulos de Costos' />
      <Portlet.Body>
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='Tipo' md={4} alignRightAt='md' />
              <Col md={8}>
                <Form.Select name='tipo-reporte' id='tipo-reporte' onChange={e => setTipoDeReporte(e.target.value)}>
                  <option key='1' value={TiposDeReporteCentrosCostos.MENSUAL}>
                    {TiposDeReporteCentrosCostos.__dictionary[TiposDeReporteCentrosCostos.MENSUAL].nombre}
                  </option>
                  <option key='2' value={TiposDeReporteCentrosCostos.ANUAL}>
                    {TiposDeReporteCentrosCostos.__dictionary[TiposDeReporteCentrosCostos.ANUAL].nombre}
                  </option>
                </Form.Select>
              </Col>
            </Form.Group>
            {tipoDeReporte === TiposDeReporteCentrosCostos.MENSUAL && (
              <>
                <Form.Group>
                  <Form.Label text='Mes' md={4} alignRightAt='md' />
                  <Col md={8}>
                    <SelectMesContabilidad
                      id='select-mes'
                      name='select-mes'
                      value={mesSeleccionado}
                      onChange={e => setMesSeleccionado(e.target.value)}
                    />
                  </Col>
                </Form.Group>
                <Row>
                  <Col md={4} />
                  <Col md={8}>
                    <Form.Checkbox
                      checked={flagAcumulado}
                      id='checkbox-flagAcumulado'
                      name='checkbox-flagAcumulado'
                      label='Acumulado'
                      onChange={() => setFlagAcumulado(prev => !prev)}
                    />
                  </Col>
                </Row>
              </>
            )}
          </Col>
        </Row>
        <Row>
          <Col md={12} className='text-right'>
            <Button onClick={clickDescargarReporte}>Descargar Reporte</Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ReporteModuloCosto)
